import { ACTIVE_USERS_STATUSES_FILTER } from '../constants';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import { Box, Toolbar, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { isBoolean, isEmpty } from 'lodash';
import React, { useMemo } from 'react';

const CustomButton = withStyles({
  label: {
    fontWeight: 600,
  },
})(Button);

const GroupToolbar = ({
  filterOption,
  activeStatuses,

  onFilterOptionChange,
  onResetFilterOps,
}) => {
  const renderValue = (array, label, defaultLabel) => {
    let value = '';
    if (array.length === 0) value = defaultLabel;
    else if (array.length === 1) value = array[0];
    else value = `${label} (${array.length})`;

    return value;
  };

  const isEmptyFilterParams = useMemo(() => {
    const filterKeys = Object.keys(filterOption);
    return filterKeys.every((key) =>
      isBoolean(filterOption[key])
        ? !filterOption[key]
        : isEmpty(filterOption[key])
    );
  }, [filterOption]);

  return (
    <Toolbar>
      <Box
        display="flex"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" gridGap={12}>
          <CustomSelectContainer
            isFullWidth
            filterValue={activeStatuses || []}
            data={ACTIVE_USERS_STATUSES_FILTER}
            renderValue={renderValue(
              activeStatuses.map(
                (it) =>
                  ACTIVE_USERS_STATUSES_FILTER.find((item) => item.key === it)
                    .value
              ),
              'Statuses',
              'All statuses'
            )}
            clearable={false}
            onChange={onFilterOptionChange('activeStatuses')}
            labelSelectAll={'All statuses'}
            useSelectAll
            checkedAll={
              ACTIVE_USERS_STATUSES_FILTER.length === activeStatuses.length
            }
          />
        </Box>

        <CustomButton
          color="primary"
          disabled={isEmptyFilterParams}
          onClick={onResetFilterOps}
        >
          Reset
        </CustomButton>
      </Box>
    </Toolbar>
  );
};

export default GroupToolbar;
